import * as yup from 'yup'

export const schemaUser = yup.object().shape({
  name: yup
    .string()
    .required()
    .max(80, 'O nome deve ter no máximo 80 caracteres'),
  description: yup
    .string()
    .required()
    .max(80, 'A descrição deve ter no máximo 80 caracteres'),
})

export default schemaUser
